export default {
      id: "Icon--socialTwitter-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#Icon--socialTwitter",
      toString: function () {
        return this.url;
      }
    }